/* eslint-disable react/no-array-index-key */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getFormValues } from 'redux-form';
import styled from 'styled-components';

import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Button from '@material-ui/core/Button';

import EditCommandBodyForm from './editCommandBodyForm/EditCommandBodyForm';
import EditCommandItemsForm from './editCommandItemsForm/EditCommandItemsForm';

import { updateCommandImportation } from '../actions';

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    borderRadius: '15px 0px 0px 0px',
    width: '41vw',
    overflowX: 'hidden'
  },
  button: {
    margin: theme.spacing(7)
  },
  form: {
    marginTop: 50
  }
}));

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-item: center;
  margin-bottom: 30px;
`;

/**
 * Drawer permettant de mettra à jour les commandes, ce drawer englobe le composant,
 * de mise à jours du body de la commande ainsi que le composant de mise à jours
 * des items de la commande
 * @param {Boolean} open                 Statut du drawer ouvert ou fermer
 * @param {Boolean} handleClose          Function permettant de fermer le drawer
 * @param {Number} commandIndex          Index de la commande actuelle
 * @param {Object[]} commands            Toutes les commandes présente dans le fichier d'import
 * @param {Object} editCommandFormValues Object contenant les nouvelles informations de la commande après la mise à jour du fomulaire
 * @param {Function} dispatchUpdateCommand Mise à jour de la commande avec les nouvelles informations
 */
const DrawerEditCommand = ({
  open,
  handleClose,
  commandIndex,
  commands,
  editCommandFormValues,
  dispatchUpdateCommand
}) => {
  const classes = useStyles();
  const command = {
    commandIndex,
    command: editCommandFormValues
  };
  return (
    <SwipeableDrawer
      classes={{
        paper: classes.drawerPaper
      }}
      anchor="right"
      onOpen={() => null}
      onClose={() => {
        handleClose();
        dispatchUpdateCommand(command);
      }}
      open={open}
    >
      <div style={{ marginLeft: 20, marginRight: 20 }}>
        <h1>
          {open && `Référence ${commands[commandIndex].externalReference}`}
        </h1>
        <ul>
          {commands.length > 0 && commands[commandIndex]
            ? commands[commandIndex].warnings.map((warning, index) =>
                warning ? (
                  <li key={index} style={{ color: '#ffc107' }}>
                    {warning}
                  </li>
                ) : null
              )
            : null}
          {commands.length > 0 && commands[commandIndex]
            ? commands[commandIndex].errorsItem.map((error, index) =>
                error ? (
                  <li key={index} style={{ color: '#dc3545' }}>
                    {error}
                  </li>
                ) : null
              )
            : null}
        </ul>
        <EditCommandBodyForm commandIndex={commandIndex} />
        <EditCommandItemsForm commandIndex={commandIndex} />
      </div>
      <ButtonContainer>
        <Button
          onClick={handleClose}
          style={{ marginRight: 20 }}
          variant="contained"
          color="secondary"
        >
          Annuler
        </Button>
        <Button
          style={{ marginLeft: 20 }}
          onClick={() => {
            dispatchUpdateCommand(command);
            handleClose();
          }}
          variant="contained"
          color="primary"
        >
          Valider
        </Button>
      </ButtonContainer>
    </SwipeableDrawer>
  );
};

DrawerEditCommand.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  dispatchUpdateCommand: PropTypes.func.isRequired,
  commands: PropTypes.array.isRequired,
  commandIndex: PropTypes.number.isRequired,
  editCommandFormValues: PropTypes.object
};

const mapStateToProps = state => ({
  editCommandFormValues: getFormValues('editCommand')(state),
  commands: state.importCommands.commands
});

const mapDispatchToProps = dispatch => ({
  dispatchUpdateCommand: command => dispatch(updateCommandImportation(command))
});

export default connect(mapStateToProps, mapDispatchToProps)(DrawerEditCommand);
